import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OutletOptions } from 'ngx-dynamic-hooks';

@Component({
    selector: 'app-render-html',
    templateUrl: './render-html.component.html',
    styleUrls: ['./render-html.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RenderHtmlComponent implements OnInit {
    @Input() html: string;
    @Input() css: string;

    outletOptions: OutletOptions = {
        sanitize: false
    };

    constructor() {}

    ngOnInit(): void {}
}
